import styled from "@emotion/styled";

import { SCMPYouTubeVideoFooter } from "./scmp-youtube-video-footer";

export const StyledSCMPYouTubeVideoFooter = styled(SCMPYouTubeVideoFooter)`
  display: none;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: flex;
  }
`;

export const SCMPYoutubeVideoContainer = styled.div`
  inline-size: 100%;
  block-size: auto;

  aspect-ratio: 16 / 9;
`;
